module.exports = __webpack_public_path__ + "img/border_rectangle3.16ae1a2a.svg";